let md = new MobileDetect(window.navigator.userAgent);
let ua = detect.parse(navigator.userAgent);

let w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName("body")[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight || e.clientHeight || g.clientHeight;


let scrollI = document.getElementById("scrollIcon");
let ismobile = false;
let openMega = null;
let currentPage = 1;
let currentPos = 0;

(function () {
  "use strict";
  console.log('JS loaded');


  if (md.mobile())
    ismobile = true;
  
/*
  if (document.querySelectorAll(".scroll-top").length > 0) {
    document.querySelectorAll('.scroll-top')[0].addEventListener("click", function (event) {
      window.scrollTo({
        'behavior': 'smooth',
        'left': 0,
        'top': 0
      });
    });
  }
*/

})();

// browser-warning
if (ua.browser.family === "IE") {
  const warning = document.querySelectorAll('.browser-warning');
  warning[0].className = 'browser-warning show';
}
